const days = {
  ru: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
};

/**
 * Возвращает сокращённое название дня недели на русском языке.
 * @param {Date} date - Объект Date.
 * @returns {string|undefined} Название дня недели (Вс, Пн, Вт, ...) или undefined.
 */
function getWeekDay(date) {
  if (!date) {
    return date;
  }
  return days.ru[date.getDay()];
}

export default getWeekDay;
